







import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import Back from '@modules/ui/buttons/Back'
import CampaignSelector from '@superUI/Selectors/CampaignSelector'

settings =
  name: "EventCampaignSelector"
  components: { SuperContainerView, Back, CampaignSelector }
  vue:
    props: ['events']

    methods:
      hiCampaignSelected: (campaign) ->
        payload =
          campaign_id: campaign.id,
          events: @events

        await @triggerSlug "campaigns/#{campaign.id}", 'add_events', payload
        @$router.push({ name: 'CampaignShowPage', params: { campaignId: campaign.id } })

export default VueOptions.vue settings
